import { styled } from '@mui/joy';

export const Overlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'flex-end',
});

export const IframeContainer = styled('div')<{ width: number }>(({ width }) => ({
  width: `${width}px`,
  height: '100%',
  backgroundColor: '#FFFFFF',
  boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  transition: 'width 0.3s ease-in-out',
}));

export const StyledIframe = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none',
  display: 'block',
});
